import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import TYPES from '../../../config/Types'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import { IStatement } from '../../../model/statement'
import { Meta } from '../../../model/meta'

export default async function fetchIgnores(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.getIsIgnored(statement).then((isIgnored: Meta<boolean>) => {
        statementStore.commitSetIsIgnored({ statement: statement, isIgnored: isIgnored.value })
    })

    return
}
